import * as React from 'react';
import { PropsWithChildren, useMemo, ReactElement } from 'react';
import { initialState, reducer } from 'state/reducers/globalProperty';
import { getGlobalProperties } from 'requests/globalProperty';
import { EActionTypes } from 'state/actions/globalProperty';
import { GlobalPropertyContext } from 'models/globalPropertyContext';

type ProviderProps = PropsWithChildren<{ children: React.ReactNode }>;
export const GlobalPropertyProvider = ({ children }: ProviderProps): ReactElement => {
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const getProperties = async () => {
    const propertiesData = await getGlobalProperties();

    if (propertiesData) {
      dispatch({
        type: EActionTypes.GET_DATA,
        payload: propertiesData,
      });
    } else {
      dispatch({ type: EActionTypes.GET_DATA, payload: [] });
    }
  };

  const value = useMemo(() => ({ ...state, getProperties }), [state]);

  return (
    <GlobalPropertyContext.Provider value={value}>{children}</GlobalPropertyContext.Provider>
  );
};
